













































































































































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {DokumentInfo, PodsetnikVozila, PovezaniDokument} from "@/services/BackendProxies";
import {formatDate, formatPrice} from "@/utils/formatters";
import dataService from '@/services/data-proxy.service'
import mixin from "vue-i18n/src/mixin";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PretragaDokumenata extends mixins(ComponentBaseMixin) {
    dokumenta: DokumentInfo[] = [];
    columns;
    filterVisible = false;
    godina = '';
    odDatuma: Date | null = null;
    doDatuma: Date | null = null;
    tipDokumenta = '';
    vozilo = '';
    dobavljac = '';
    status = '';
    statusi = [];
    tipoviDokumenata = [];
    dokument = new DokumentInfo();
    pregledDokumentaVidljiv = false;

    datum = '';
    detaljiDokumentaVisible = true;
    povezaniDokumentiVisible = true;
    sopstveniDeloviColumns = [];
    servisneOperacijeColumns = [];
    fakturisaniDeloviColumns = [];
    stavkePrijemniceColumns = [];
    povezanaDokumentaColumns = [];
    ostaliTroskoviColumns = [];

    povezanaDokumenta = [];
    pregledanaDokumenta = [];

    async created() {
        this.tipoviDokumenata = [
            {id: '', text: '...'},
            {id: 'RadniNalog', text: 'Radni nalog'},
            {id: 'Faktura', text: 'Faktura'},
            {id: 'Izdatnica', text: 'Izdatnica'},
            {id: 'Trebovanje', text: 'Trebovanje'},
            {id: 'Povratnica', text: 'Povratnica'},
            {id: 'Prijemnica', text: 'Prijemnica'},
        ];
        this.statusi = [
            {id: '', text: '...'},
            {id: '0', text: 'otvoren'},
            {id: '1', text: 'zatvoren'},
            {id: '2', text: 'potvrdjen'},
        ];
        this.columns = [
            {field: 'broj', title: '#'},
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate},
            {field: 'tip', title: this.$i18n.t('tip')},
            {field: 'vozilo', title: this.$i18n.t('vozilo')},
            {field: 'dobavljac', title: this.$i18n.t('dobavljac')},
            {field: 'osnovica', title: this.$i18n.t('osnovica'), formatter: formatPrice, align: 'right'},
            {field: 'pdv', title: this.$i18n.t('pdv'), formatter: formatPrice, align: 'right'},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: formatPrice, align: 'right'},
            {field: 'dokumentKreirao', title: this.$i18n.t('dokumentKreirao')},
            {field: 'status', title: this.$i18n.t('status'), formatter: this.statusFormatter, width: 50},
        ];
        this.sopstveniDeloviColumns = [
            {field: 'sifra', title: this.$i18n.t('sifra')},
            {field: 'kataloskiBroj', title: this.$i18n.t('kataloskiBroj')},
            {field: 'opis', title: this.$i18n.t('opis')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'utrosenaKolicina', title: this.$i18n.t('utroseno'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'cena', title: this.$i18n.t('cena'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'osnovica', title: this.$i18n.t('osnovica'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'pdv', title: this.$i18n.t('pdv'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: value => formatPrice(value), align: 'right'},
        ];
        this.servisneOperacijeColumns = [
            {field: 'opis', title: this.$i18n.t('opis')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'cena', title: this.$i18n.t('cena'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'rabat', title: this.$i18n.t('popust'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'osnovica', title: this.$i18n.t('osnovica'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'pdv', title: this.$i18n.t('pdv'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: value => formatPrice(value), align: 'right'},
        ];
        this.fakturisaniDeloviColumns = [
            {field: 'opis', title: this.$i18n.t('opis')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'cena', title: this.$i18n.t('cena'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'rabat', title: this.$i18n.t('popust'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'osnovica', title: this.$i18n.t('osnovica'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'pdv', title: this.$i18n.t('pdv'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: value => formatPrice(value), align: 'right'},
        ];
        this.stavkePrijemniceColumns = [
            {field: 'kataloskiBroj', title: this.$i18n.t('kataloskiBroj')},
            {field: 'opis', title: this.$i18n.t('opis')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'cena', title: this.$i18n.t('cena'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: value => formatPrice(value), align: 'right'},
        ];
        this.povezanaDokumentaColumns = [
            {field: 'broj', title: '#'},
            {field: 'datum', title: this.$i18n.t('datum'), formatter: datum => formatDate(datum)},
            {field: 'tip', title: this.$i18n.t('tip')},
        ];
        this.ostaliTroskoviColumns = [
            {field: 'opis', title: this.$i18n.t('opis')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'cena', title: this.$i18n.t('cena'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'rabat', title: this.$i18n.t('popust'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'osnovica', title: this.$i18n.t('osnovica'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'pdv', title: this.$i18n.t('pdv'), formatter: value => formatPrice(value), align: 'right'},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: value => formatPrice(value), align: 'right'},
        ];
        this.pretrazi();
    }

    statusFormatter(status: number) {
        switch (status) {
            case 0: return '<i class="fa fa-folder-open"></i>';
            case 1: return '<i class="fa fa-folder"></i>';
            case 2: return '<i class="fa fa-check"></i>';
        }
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    get postavljenFilter() {
        return this.godina || this.odDatuma || this.doDatuma || this.tipDokumenta || this.vozilo;
    }

    @Watch('godina')
    @Watch('odDatuma')
    @Watch('doDatuma')
    @Watch('vozilo')
    @Watch('tipDokumenta')
    @Watch('dobavljac')
    @Watch('status')
    async pretrazi() {
        this.dokumenta = await this.loadData(() => dataService.pretraziDokumenteOdrzavanja(
            this.tipDokumenta, +this.godina, +this.vozilo, +this.dobavljac, this.odDatuma, this.doDatuma, undefined))();
    }

    @Watch('pregledDokumentaVidljiv')
    onPregledDokumentaViddljivChanged(vidljiv: boolean) {
        if (!vidljiv) {
            this.pregledanaDokumenta = [];
        }
    }

    async pregledajDokument(dokument: DokumentInfo) {
        this.dokument = new DokumentInfo();
        this.povezanaDokumenta = [];
        this.pregledDokumentaVidljiv = true;
        this.dokument = await this.loadData(() => dataService.vratiPregledDokumenta(dokument.tip, dokument.id))();
        this.datum = formatDate(this.dokument.datum);
        this.povezanaDokumenta = await this.loadData(() => dataService.vratiPovezanaDokumenta(dokument.id))();
    }

    async selektovanPovezaniDokument(povezaniDokument: PovezaniDokument) {
        this.pregledanaDokumenta.push(this.dokument);
        await this.pregledajDokument(DokumentInfo.fromJS({id: povezaniDokument.id, tip: povezaniDokument.tip}));
    }

    async prethodniDokument() {
        this.dokument = this.pregledanaDokumenta.pop();
        this.datum = formatDate(this.dokument.datum);
        this.povezanaDokumenta = await this.loadData(() => dataService.vratiPovezanaDokumenta(this.dokument.id))();
    }
}
